enum CustomerUserRoutesAPI {
  CUSTOMER_USER_LIST = '/customer-portal-service/User',
}

enum CustomerUserRoutesApplication {
  CUSTOMER_USER_LIST = '/application/user',
  CUSTOMER_USER_ITEM = '/application/customer-user/:id',
}

export {
  CustomerUserRoutesAPI,
  CustomerUserRoutesApplication,
};
